import {
  createFrontendPlugin,
  PageBlueprint,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import HomeIcon from '@material-ui/icons/Home';
import { createElement } from 'react';

const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    title: 'Home',
    icon: createElement(HomeIcon),
    noHeader: true,
    loader: async () => {
      const { HomePage } = await import('./HomePage');
      return createElement(HomePage);
    },
  },
});

export const homePlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'home',
  extensions: [homePage],
});
